import { render, staticRenderFns } from "./long-left-arrow.vue?vue&type=template&id=890d4624&scoped=true"
import script from "./long-left-arrow.vue?vue&type=script&lang=js"
export * from "./long-left-arrow.vue?vue&type=script&lang=js"
import style0 from "./long-left-arrow.vue?vue&type=style&index=0&id=890d4624&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "890d4624",
  null
  
)

export default component.exports